/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListModelProviderKeysSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListModelProviderKeysSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListModelProviderKeysSecurity = {
  option1?: ListModelProviderKeysSecurityOption1 | undefined;
  option2?: ListModelProviderKeysSecurityOption2 | undefined;
};

export type ListModelProviderKeysRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListModelProviderKeysSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListModelProviderKeysSecurityOption1$outboundSchema: z.ZodMiniType<
  ListModelProviderKeysSecurityOption1$Outbound,
  ListModelProviderKeysSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listModelProviderKeysSecurityOption1ToJSON(
  listModelProviderKeysSecurityOption1: ListModelProviderKeysSecurityOption1,
): string {
  return JSON.stringify(
    ListModelProviderKeysSecurityOption1$outboundSchema.parse(
      listModelProviderKeysSecurityOption1,
    ),
  );
}

/** @internal */
export type ListModelProviderKeysSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListModelProviderKeysSecurityOption2$outboundSchema: z.ZodMiniType<
  ListModelProviderKeysSecurityOption2$Outbound,
  ListModelProviderKeysSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listModelProviderKeysSecurityOption2ToJSON(
  listModelProviderKeysSecurityOption2: ListModelProviderKeysSecurityOption2,
): string {
  return JSON.stringify(
    ListModelProviderKeysSecurityOption2$outboundSchema.parse(
      listModelProviderKeysSecurityOption2,
    ),
  );
}

/** @internal */
export type ListModelProviderKeysSecurity$Outbound = {
  Option1?: ListModelProviderKeysSecurityOption1$Outbound | undefined;
  Option2?: ListModelProviderKeysSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListModelProviderKeysSecurity$outboundSchema: z.ZodMiniType<
  ListModelProviderKeysSecurity$Outbound,
  ListModelProviderKeysSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListModelProviderKeysSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListModelProviderKeysSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listModelProviderKeysSecurityToJSON(
  listModelProviderKeysSecurity: ListModelProviderKeysSecurity,
): string {
  return JSON.stringify(
    ListModelProviderKeysSecurity$outboundSchema.parse(
      listModelProviderKeysSecurity,
    ),
  );
}

/** @internal */
export type ListModelProviderKeysRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListModelProviderKeysRequest$outboundSchema: z.ZodMiniType<
  ListModelProviderKeysRequest$Outbound,
  ListModelProviderKeysRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listModelProviderKeysRequestToJSON(
  listModelProviderKeysRequest: ListModelProviderKeysRequest,
): string {
  return JSON.stringify(
    ListModelProviderKeysRequest$outboundSchema.parse(
      listModelProviderKeysRequest,
    ),
  );
}
